import React, { useState, useEffect, useRef } from 'react';

import { reqGET, repo_img_link, content_language, translate } from '../../../../Utils';

import * as Hosts from "../../../../Hosts";

import { language } from '../Language';

import { Navigation, Pagination, Autoplay, Scrollbar, A11y, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import "swiper/swiper-bundle.min.css";

import parse from 'html-react-parser';
import AssecImage from "../../ASSEC_Image/Image"

import Loader from '../../../../loader';
// import "../../Pagina.css";
import "./HomeNews_01.css"

const HomeNews = (props) => {

	const [, set_dados] = useState(null)
	const news_list = useRef([])
	const dados_config = useRef([])

    const [news_title, set_news_title] = useState('')
    const [news_subtitle, set_news_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'news' && el.info.active) {
                    set_news_title(translate(el.info.title, lang))
                    set_news_subtitle(translate(el.info.subtitle, lang))
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        let getNews = async () => {
            reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/news`)
                .then(res => {

                    set_dados(news_list.current = res.data)
                    setLoading(false)

                }).catch(erro => console.log('Erro1', erro))
        }
        getNews()

    }, [props, lang])

    function get_image_content(el, type) {
  
      let result = ''
  
  
        if(parseInt(lang_id) !== 1 && el.content[0]['language'] !== undefined && el.content[0]['language'][lang_id] !== undefined && el.content[0]['language'][lang_id] !== null && el.content[0]['language'][lang_id]['media'] !== null && el.content[0]['language'][lang_id]['media']['image'] !== undefined && el.content[0].language[lang_id]['media']['image'].length > 0) { 
          if(type === 'name') {
            result = el.content[0].language[lang_id].media.image[0].name
          }
          else if(type === 'url') {
            result = el.content[0].language[lang_id].media.image[0].url
          }
          else if(type === 'link') {
            result = el.content[0].language[lang_id].media.image[0].link
          }
        } else {
          if(el.content[0].media.image !== undefined && el.content[0].media.image !== null && el.content[0].media.image.length > 0) {
  
            if(type === 'name') {
              result = el.content[0].media.image[0].name
            }
            else if(type === 'url') {
              result = el.content[0].media.image[0].url
            }
            else if(type === 'link') {
              result = el.content[0].media.image[0].link
            }
    
          }
  
        }
  
      return result
    }

    return (
        isloading ?
            <Loader />
		:
            <section id="homenews_01" className='div-component'>
                <div className="container">
                    <div className="row">
                        <div className="col-12 title-properties">
                            <h3 className="titulo-pp">
                            {news_title}
                            </h3>
                            {
                            news_subtitle !== '' ?
                                <h4 className={"subtitulo-pp"}>
                                {news_subtitle}
                                </h4>
                            :
                            null
                            }
                            <hr></hr>
                        </div>
                        <div className='col-12'>
                            {
                            news_list.current !== undefined && news_list.current !== null && news_list.current.length > 0 ?
                            <>
                                <div className="swiper-container swiper-noticias">
                                    <Swiper className="p-1" modules={[Autoplay, Navigation, EffectFade, Pagination, Scrollbar, A11y]}
                                        speed={7000}
                                        loop={false}
                                        autoHeight={false}
                                        autoplay={{
                                        delay: 20000,
                                        disableOnInteraction: false,
                                        }}
                                        spaceBetween={15}
                                        slidesPerView={3}
                                    //navigation
                                        pagination={{
                                        el: '.swiper-pagination-noticias',
                                        clickable: true
                                        }}
                                    //scrollbar={{ draggable: true }}
                                    breakpoints={{
                                    // when window width is >= 0px
                                        0: {
                                        slidesPerView: 1,
                                        },
                                    // when window width is >= 768px
                                        768: {
                                        slidesPerView: 2,
                                        },
                                        992: {
                                        slidesPerView: 3,
                                        },
                                        1200: {
                                        slidesPerView: 3
                                        },
                                    }}
                                    >
                                        {
                                        news_list.current.map((v, key) => {
                                            return (
                                                <SwiperSlide key={key}>
                                                    <div className="card">
                                                        <a href={'./article/' + v.id} title={parse(v.content[0].title)} >
                                                            <div className="noticia-img">
                                                                <AssecImage
                                                                    linkImage={get_image_content(v, 'link') !== '' ? get_image_content(v, 'link') : repo_img_link('nophoto.webp')}
                                                                    width="450"
                                                                    height="338"
                                                                    fit='crop'
                                                                    type='img'
                                                                    sClass='img-fluid'
                                                                    alt={get_image_content(v, 'name')}
                                                                    title={get_image_content(v, 'name')}
                                                                />
                                                            </div>
                                                        </a>
                                                        <div className="card-body">
                                                            <div className="timestamp">{parse(v.info.date.published.split('T')[0])}</div>
                                                            <div className="card-title">
                                                                {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title))}
                                                            </div>
                                                            <div className="card-text">
                                                                {parse((lang === 'pt' || v.content[0].language === undefined ? v.content[0].abstract : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].abstract === undefined || v.content[0].language[lang_id].abstract === '' ? v.content[0].abstract : v.content[0].language[lang_id].abstract)))}
                                                            </div>
                                                        </div>
                                                        <div className="px-3 mb-3 text-end">
                                                            <a className="btn btn-text" href={'./article/' + v.id}>{language[lang].learn_more}<i className="bi bi-chevron-right"></i></a>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                        }
                                        <div className="swiper-pagination-noticias mt-5"></div>
                                    </Swiper>
                                </div>
                                <div className="col-12 mt-5 text-center">
                                    <a className="btn btn-primary" href={'./article/all'} >{language[lang].see_it_all}</a>
                                </div>
                            </>
                            :
                            null
                            }
                        </div>
                    </div>
                </div>
            </section>
    )
};
export default HomeNews;